'use client';

import styles from './SuggestiveChips.module.css';

export const SuggestiveChips = ({
  className,
  data,
  onClick,
}: {
  className?: string;
  data: ReadonlyArray<{
    emoji: string;
    title: string;
  }>;
  onClick?: (input: string) => void;
}) => {
  return (
    <div className={className ? `${styles.root} ${className}` : styles.root}>
      <div className={styles.marquee}>
        <div className={styles.marqueeContent}>
          {data.map(({ emoji, title }, index) => (
            <button
              key={index}
              className={styles.marqueeItem}
              onClick={() => (onClick ? onClick(title) : null)}
            >
              {emoji} {title}
            </button>
          ))}
          {data.map(({ emoji, title }, index) => (
            <button
              key={index + data.length}
              className={styles.marqueeItem}
              onClick={() => (onClick ? onClick(title) : null)}
            >
              {emoji} {title}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
